export function isAndroid(userAgent) {
    return !!userAgent.match(/(Android)/i);
}

export function isMobile(userAgent) {
    return !!userAgent.match(/(Android|webOS|iPhone|iPad|iPod|BlackBerry|Windows Phone)/i);
}

export function isIOS(userAgent) {
    const isSafari = !!userAgent.match(/Version\/[\d.]+.*Safari/);
    const iOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    return isSafari && iOS;
}